import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { queryClient } from '@/shared/api/query-client';
import { ConfirmDialogHost, Toaster, TooltipProvider } from '@/shared/ui';
import { router } from './router';

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <RouterProvider router={router} />
        <Toaster />
        <ConfirmDialogHost />
      </TooltipProvider>
    </QueryClientProvider>
  );
}
